import {Expose} from 'class-transformer';

export class UserPaymentApiModel {
  @Expose()
  id: string;

  @Expose()
  name: string;
}
